<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-start">
      <div>
        <Breadcrumbs
          :headline="item.importOrderCode"
          :link="[{ text: 'Danh sách giao nhận hàng nhập', href: '/delivery' }]"
          :chip="{
            show: true,
            color: item.status === 'open' ? 'green' : 'red',
            textColor: 'white',
            text: item.status === 'open' ? 'Đang mở' : 'Đã đóng'
          }"
        />
      </div>
      <SelectStatusCard :status="item.deliveryStatus" />
    </div>
    <div class="pa-4">
      <div class="delivery-detail__header-text">
        Giao nhận theo đơn hàng nhập {{ get(item, 'productIndustry.name', '--') }} /
        {{ get(item, 'producer.name', '--') }} / {{ get(item, 'productType.name', '--') }} - Ngày
        {{ deliveredAt ? formatDateDDMMYYYY(deliveredAt) : '--/--' }}
      </div>
      <div class="d-flex justify-space-between align-center mb-6">
        <h2>Lịch hàng về</h2>
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="ml-2" text v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <ImportExcelDelivery @onRefresh="onRefresh" />
        </v-menu>
      </div>
      <TableInventory
        class="mt-6"
        :loading="loading"
        @onRefresh="data => onRefresh(data)"
        @onSearch="data => onSearch(data)"
      />
      <div v-if="item.importOrder && isShowReceivedTable">
        <ReceivedProductsTable class="mt-6" :importDelivery="item" />
      </div>
      <HistoryLog class="mt-6" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { get } from 'lodash'
import moment from 'moment'
import HistoryLog from '../../modules/deliveryManagement/HistoryLog.vue'
import ReceivedProductsTable from '../../modules/deliveryManagement/ReceivedProductsTable.vue'
import TableInventory from '../../modules/deliveryManagement/TableInventory/index.vue'
import ImportExcelDelivery from '../../modules/deliveryManagement/ImportExcelDelivery.vue'
import SelectStatusCard from './SelectStatusCard.vue'
import { formatDateDDMMYYYY } from '@/helpers/date.js'
export default {
  components: {
    Breadcrumbs,
    HistoryLog,
    ReceivedProductsTable,
    TableInventory,
    ImportExcelDelivery,
    SelectStatusCard
  },
  computed: {
    ...mapState('importDeliveries', ['item', 'deliveredAt', 'expectQuantity'])
  },
  data() {
    return {
      get,
      moment,
      orderId: null,
      loading: true,
      isMappingDone: true,
      isShowReceivedTable: false
    }
  },
  methods: {
    ...mapActions({
      fetchItem: 'importDeliveries/fetchOne',
      fetchInventories: 'importDeliveries/fetchInventories',
      setHistory: 'importDeliveries/setHistory',
      fetchExpectQuantity: 'importDeliveries/fetchExpectQuantity',
      countProducts: 'importDeliveries/countProducts'
    }),
    formatDateDDMMYYYY: formatDateDDMMYYYY,
    async onRefresh(data = {}) {
      this.loading = true
      try {
        await this.fetchInventories({
          id: this.orderId,
          params: data
        })
        await this.countProducts({
          importOrder: this.orderId,
          code_contains: get(data, 'code_contains', ''),
          description_contains: get(data, 'description_contains', '')
        })
        await this.fetchExpectQuantity({ id: this.orderId })
        if (this.$route.params.id) await this.setHistory(this.$route.params.id)
      } catch (error) {
        this.$alert.error(error.message)
      } finally {
        setTimeout(() => {
          this.loading = false
        }, 2000)
      }
    },
    async onSearch(data) {
      this.loading = true
      try {
        await this.fetchInventories({
          id: this.orderId,
          params: data
        })
        await this.fetchExpectQuantity({
          id: this.orderId,
          params: {
            code_contains: data.code_contains || '',
            description_contains: data.description_contains || ''
          }
        })
        await this.countProducts({
          importOrder: this.orderId,
          code_contains: data.code_contains || '',
          description_contains: data.description_contains || ''
        })
      } catch (error) {
        this.$alert.error(error.message)
      } finally {
        this.loading = false
      }
    },
    async fetchDataOnMount(id) {
      try {
        if (id) {
          this.loading = true
          await this.fetchItem(id)
          await this.setHistory(id)
          this.orderId = get(this.item, 'importOrder.id')
          if (this.orderId) {
            await this.fetchExpectQuantity({ id: this.orderId })
            await this.fetchInventories({
              id: this.orderId,
              params: {
                _start: 0,
                _limit: 10
              }
            })
            await this.countProducts({ importOrder: this.orderId })
          }
        }
        if (this.isMappingDone) this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  },
  watch: {
    expectQuantity: {
      handler(val) {
        if (val && val.quantityByDeliveredAt && Object.keys(val.quantityByDeliveredAt).length > 0) {
          this.isShowReceivedTable = true
        }
      },
      immediate: true,
      deep: true
    },
    '$route.params.id': {
      async handler(val) {
        if (val) await this.fetchDataOnMount(val)
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
.status-card {
  background: rgb(202, 202, 202);
  border: 1px solid;
}

.delivery-detail__header-text {
  font-size: 32px;
  margin-bottom: 12px;
}
</style>
